export default __webpack_public_path__ + "static/media/call-end-red.f4fbacff.svg";